var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkIcon = function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.996 13.067a6 6 0 0 0-4.22 1.684l-.01.01-1.72 1.71a1 1 0 0 0 1.41 1.418l1.714-1.704a4 4 0 0 1 5.657 5.654l-2.994 2.994a4 4 0 0 1-6.032-.432 1 1 0 1 0-1.602 1.198 6 6 0 0 0 9.048.648l3-3 .013-.012a6 6 0 0 0-4.264-10.168m-6.571 6.943a6 6 0 0 0-4.672 1.743l-3 3-.012.012a6 6 0 0 0 8.484 8.484l.012-.012 1.71-1.71a1 1 0 0 0-1.414-1.414l-1.703 1.703a4 4 0 0 1-5.656-5.655l2.993-2.994a4 4 0 0 1 6.032.432 1 1 0 0 0 1.602-1.198 6 6 0 0 0-4.376-2.39",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    x: 1,
    y: 1,
    stroke: "#fff",
    strokeWidth: 2,
    rx: 23
  })));
};
export default SvgLinkIcon;